import { useSelector, useDispatch } from "react-redux";
import MainPageLayout from "../../layout/MainPageLayout";
import useGetHistory from "../../CustomHooks/useAxios/useGetHistory";
import NoExpenseHistoryView from "../../components/expense/all/history/NoExpenseHistoryView";
import ExpenseHistorySelector from "../../components/expense/all/history/ExpenseHistorySelector";
import ExpenseHistoryResultsContainer from "../../components/expense/all/history/expenseHistoryResults/ExpenseHistoryResultsContainer";
import DialogBox from "../../components/UI/DialogBox";
import { handleErrMessage } from "../../functions/handleErrMessage";
import { setError } from "../../redux/dataSlice";

const ExpenseHistoryPage = () => {
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.data);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);

  return (
    <>
      <MainPageLayout
        headerConfig={{ title: "Expense History" }}
        bgColor="bg-dBlue-100"
      >
        <div className="flex gap-4 max-lg:gap-2 my-3 h-[calc(100vh-5em)] max-lg:h-[calc(100vh-4em)] max-md:h-[calc(100vh-5em)] flex-col">
          <ExpenseHistorySelector
            historyLoaded={historyLoaded}
            getHistory={getHistory}
          />

          <div className="bg-white h-full rounded-lg border-1 border-dBlue-100 max-lg:p-3 px-5 py-3">
            {isSucceed && data?.expenses?.length ? (
              <ExpenseHistoryResultsContainer />
            ) : (
              <NoExpenseHistoryView
                isSucceed={isSucceed}
                dataLength={data?.expenses?.length}
              />
            )}
          </div>
        </div>
      </MainPageLayout>
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </>
  );
};

export default ExpenseHistoryPage;
